import { useState } from 'react';
import WizardModal, { WizardButton, WizardLabel, WizardInput, WizardSuccess, WizardError } from './WizardModal';
import useWizardSubmit from './useWizardSubmit';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function WeightWizard({ open, onClose }: Props) {
  const [weightKg, setWeightKg] = useState('');
  const [date, setDate] = useState(todayISO());
  const [note, setNote] = useState('');
  const { status, error, submit, reset } = useWizardSubmit();

  const handleSubmit = async () => {
    const kg = parseFloat(weightKg.replace(',', '.'));
    if (isNaN(kg) || kg <= 0) return;
    await submit('/weight', { weight_kg: kg, date, note: note || undefined });
  };

  const handleClose = () => {
    setWeightKg('');
    setDate(todayISO());
    setNote('');
    reset();
    onClose();
  };

  if (status === 'success') {
    return (
      <WizardModal open={open} onClose={handleClose} title="Gewicht" footer={null}>
        <WizardSuccess message="Gewicht gespeichert!" onDone={handleClose} />
      </WizardModal>
    );
  }

  return (
    <WizardModal
      open={open}
      onClose={handleClose}
      title="Gewicht eintragen"
      footer={
        <WizardButton onClick={handleSubmit} loading={status === 'loading'} disabled={!weightKg.trim()}>
          Speichern
        </WizardButton>
      }
    >
      {error && <WizardError message={error} />}

      <div>
        <WizardLabel>Gewicht (kg)</WizardLabel>
        <WizardInput
          value={weightKg}
          onChange={setWeightKg}
          placeholder="z.B. 72.5"
          type="number"
          step="0.1"
          min="30"
          max="300"
          autoFocus
        />
      </div>

      <div>
        <WizardLabel>Datum</WizardLabel>
        <WizardInput type="date" value={date} onChange={setDate} />
      </div>

      <div>
        <WizardLabel>Notiz (optional)</WizardLabel>
        <WizardInput value={note} onChange={setNote} placeholder="z.B. nach dem Sport" />
      </div>
    </WizardModal>
  );
}

function todayISO(): string {
  return new Date().toLocaleDateString('sv-SE'); // YYYY-MM-DD
}
